import { memoize } from "lodash-es";

/**
 * This is an extension of lodash.memoize,
 * which also adds an expiry time to the cached results.
 */
export const createCached = <T, Args extends unknown[]>(
  fn: (...args: Args) => Promise<T>,
  ttlSeconds: number,
): ((...args: Args) => Promise<T>) => {
  const memoizedCall = memoize(fn, (...args: Args) => {
    return JSON.stringify(args);
  });
  let timeout: NodeJS.Timeout | null = null;
  const expireCache = () => {
    if (memoizedCall.cache?.clear) {
      memoizedCall.cache.clear();
    }
    timeout = null;
  };

  return (...args: Args) => {
    // Note that this means we will clear the cache <ttlSeconds>
    // seconds after the first call, and then the following call after expiry
    // will re-trigger the timeout.
    if (!timeout) {
      timeout = setTimeout(expireCache, ttlSeconds * 1000);
    }
    return memoizedCall(...args);
  };
};
